import React, { useEffect, useMemo, useState } from 'react';
import { useTable } from 'react-table';
import ArrayIsEmpty from '../../UI/Array-is-empty/Array-is-empty';
import Pagination from '../../UI/Pagination/Pagination';
import s from './styles.module.css';

const ProductReportTable = ({ tableOrder, translation, language, page, setPage, role }) => {
    const [tableData, setTableData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        if (tableOrder) {
            if (Array.isArray(tableOrder)) {
                setTableData(tableOrder);
                setTotalPages(tableOrder.totalPages ?? 0);
            } else if (tableOrder.data && Array.isArray(tableOrder.data)) {
                setTableData(tableOrder.data);
                setTotalPages(tableOrder.totalPages ?? 0);
            } else {
                setTableData([tableOrder]);
                setTotalPages(1);
            }
        } else {
            setTableData([]);
            setTotalPages(0);
        }
    }, [tableOrder]);
    const columns = useMemo(
        () => [
            {
                Header: translation('Город') || 'Город',
                accessor: 'city',
            },
            {
                Header: translation('Количество заказов') || 'Количество заказов',
                accessor: 'orderCount',
            },
            {
                Header: translation('Цена при приёме') || 'Цена при приёме',
                accessor: 'priceAtTake',
            },
            {
                Header: translation('Выданная сумма') || 'Выданная сумма',
                accessor: 'givenAmount',
            },
            {
                Header: translation('Должны Филиалу') || 'Должны Филиалу',
                accessor: 'owedAmountByAman',
            },
        ],
        [translation, language, role],
    );

    const tableInstance = useTable({
        columns,
        data: tableData,
    });

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

    return (
        <div>
            <div className={s['table-order']}>
                {tableData.length === 0 ? (
                    <ArrayIsEmpty textOfEmpty={translation('emptyPageOrder')} />
                ) : (
                    <>
                        <table className={s['table']} {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => {
                                    const { key: headerGroupKey, ...headerGroupRest } =
                                        headerGroup.getHeaderGroupProps();
                                    return (
                                        <tr key={headerGroupKey} {...headerGroupRest}>
                                            {headerGroup.headers.map((column) => {
                                                const { key: columnKey, ...columnRest } =
                                                    column.getHeaderProps();
                                                return (
                                                    <th
                                                        key={columnKey}
                                                        className={s['th-style']}
                                                        {...columnRest}
                                                    >
                                                        {column.render('Header')}
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {rows.map((row) => {
                                    prepareRow(row);
                                    const { key: rowKey, ...rowRest } = row.getRowProps();
                                    return (
                                        <tr className={s['tbody']} key={rowKey} {...rowRest}>
                                            {row.cells.map((cell) => {
                                                const { key: cellKey, ...cellRest } =
                                                    cell.getCellProps();
                                                return (
                                                    <td
                                                        key={cellKey}
                                                        className={s['td-style']}
                                                        {...cellRest}
                                                    >
                                                        {cell.render('Cell')}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className={s['mobile-view']}>
                            {rows.map((row) => {
                                prepareRow(row);
                                return (
                                    <div key={row.id} className={s['mobile-row']}>
                                        {row.cells.map((cell, cellIndex) => (
                                            <div
                                                key={cell.column.id}
                                                className={`${s['mobile-cell']} ${
                                                    cellIndex === row.cells.length - 1
                                                        ? s['with-line']
                                                        : ''
                                                }`}
                                            >
                                                <div className={s['mobile-header']}>
                                                    <span className={s['row-text-1']}>
                                                        {cellIndex === row.cells.length - 1
                                                            ? ''
                                                            : `${cell.column.render('Header')}:`}
                                                    </span>
                                                </div>
                                                <div className={s['mobile-content']}>
                                                    <span className={s['row-text']}>
                                                        {cell.render('Cell')}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>

            <div className={s['div-pages']}>
                {totalPages > 1 && (
                    <Pagination totalPages={totalPages} currentPage={page} setPage={setPage} />
                )}
            </div>
        </div>
    );
};

export default ProductReportTable;
